import axios from 'axios';
import TokenService from '../utility/tokenControl';
import router from '../router/index';

const API_ENDPOINT = 'https://sandbox.api.omninext.app/api/';

const authHeader = () => ({
  Authorization: `Bearer ${TokenService.get()}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    Authorization: `Bearer ${TokenService.get()}`,
    'Content-Type': 'application/json',
  },
});

class DataService {
  static get(path = '', params = {}) {
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
      params,
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
      method: 'POST',
      url: path,
      data,
      headers: { ...authHeader(), ...optionalHeader },
    });
  }

  static patch(path = '', data = {}) {
    return client({
      method: 'PATCH',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static delete(path = '', data = {}) {
    return client({
      method: 'DELETE',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: JSON.stringify(data),
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = { ...headers, Authorization: `Bearer ${TokenService.get()}` };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => {
    const { headers } = response;
    if (headers && headers.authorization) {
      TokenService.set(headers.authorization);
    }

    return response;
  },
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    if (response) {
      const { data } = response;
      if (data.error !== 'could_not_get_product') {
        this.$toast.error(data.message);
      }
      if (response.status === 500) {
        // TODO: handling error exception globally
      } else if (response.status === 401) {
        TokenService.remove();
        router.push({
          name: 'login',
        });
      } else if (response.status === 403) {
        router.push({
          name: 'support',
        });
      }
    }
    return Promise.reject(response);
  },
);
export { DataService };
